import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_ADMINS, UPDATE_ADMIN_STATUS, DELETE_ADMIN, ADD_ADMIN, EDIT_ADMIN, RESET_PASSWORD_ADMIN, GET_MODULES } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetAdminSuccess, GetAdminsFailure, UpdateAdminStatusSuccess, UpdateAdminStatusFailure, DeleteAdminSuccess, DeleteAdminFailure, AddAdminSuccess, AddAdminFailure, EditAdminSuccess, EditAdminFailure, ResetPasswordAdminSuccess, ResetPasswordAdminFailure, GetModulesSuccess, GetModulesFailure } from "../Actions/AdminAction";

function* GetAdminRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/admins?status=${actions.payload.status}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetAdminSuccess(res.data));
    } else {
      yield put(GetAdminsFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetAdminsFailure(e));
  }
}

function* UpdateAdminStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_admin_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateAdminStatusSuccess(res.data));
    } else {
      yield put(UpdateAdminStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateAdminStatusFailure(e));
  }
}

function* DeleteAdminRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/admin/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteAdminSuccess(res.data));
    } else {
      yield put(DeleteAdminFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteAdminFailure(e));
  }
}

function* AddAdminRequest(actions) {
  const admin = {
    first_name: actions.payload.first_name,
    last_name: actions.payload.last_name,
    email: actions.payload.email,
  };

  let permissions = actions.payload.permissions;

  const body = {
    admin,
    permissions,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_admin`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(AddAdminSuccess(res.data));
    } else {
      yield put(AddAdminFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddAdminFailure(e));
  }
}

function* EditAdminRequest(actions) {
  const admin = {
    id: actions.payload.id,
    first_name: actions.payload.first_name,
    last_name: actions.payload.last_name,
    email: actions.payload.email,
  };

  let permissions = actions.payload.permissions;

  const body = {
    admin,
    permissions,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_admin`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(EditAdminSuccess(res.data));
    } else {
      yield put(EditAdminFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditAdminFailure(e));
  }
}

function* ResetPasswordAdminRequest(actions) {
  const body = {
    id: actions.payload,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/generate_reset_password_link`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(ResetPasswordAdminSuccess(res.data));
    } else {
      yield put(ResetPasswordAdminFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(ResetPasswordAdminFailure(e));
  }
}

function* GetModulesRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/modules`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(GetModulesSuccess(res.data));
    } else {
      yield put(GetModulesFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetModulesFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_ADMINS, GetAdminRequest);
  yield takeLatest(UPDATE_ADMIN_STATUS, UpdateAdminStatusRequest);
  yield takeLatest(DELETE_ADMIN, DeleteAdminRequest);
  yield takeLatest(ADD_ADMIN, AddAdminRequest);
  yield takeLatest(EDIT_ADMIN, EditAdminRequest);
  yield takeLatest(RESET_PASSWORD_ADMIN, ResetPasswordAdminRequest);
  yield takeLatest(GET_MODULES, GetModulesRequest);
}

export default function* AdminSaga() {
  yield all([actionWatcher()]);
}
